interface RequestOptions {
  method: 'GET' | 'POST' | 'DELETE';
  url: string;
  params?: string;
  headers?: Object;
}

export function makeRequest<T>(opts: RequestOptions): Promise<T> {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open(opts.method, opts.url);
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        try {
          const json: T = JSON.parse(xhr.response);
          resolve(json);
        } catch (e) {
          return resolve(xhr.response);
        }
        return resolve(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText,
        });
      }
    };
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText,
      });
    };
    if (opts.headers) {
      Object.keys(opts.headers).forEach((key) => {
        xhr.setRequestHeader(key, opts.headers[key]);
      });
    }
    xhr.send(opts.params);
  });
}
